<template>
  <div>
    <div class="modal" :class="{ show: modalState }">
      <!-- Modal content -->
      <div class="modal-content bg-transparent">
        <div class="modal-header">
          <!-- Top section -->
          <div class="top-section">

            <div class="person d-block">{{ personName }}</div>
            <div class="time d-block">{{ time }}</div>
          </div>
          <!-- Close button -->
          <span class="close" @click="toggleModal">&times;</span>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
            <button v-if="images.length>1"  @click.stop="nextImage" class="bg-gray-400 sider-btn-prev">
              <span class="arrow left"></span>
            </button>
            <button v-if="images.length>1" @click.stop="prevImage" class="bg-gray-400 sider-btn-next">
                <span class="arrow right"></span>
            </button>
          <!-- Main section -->
          <div class="main-section zoom-container">
            <vue-image-zoomer
                :regular="lCurrentImage?lCurrentImage:currentImage"
                :click-zoom="true"
                :zoom-amount="2"
                :img-class="'zoomed-image mh-700px'"
                :img-height="700"
                :zoom="lCurrentImage?lCurrentImage:currentImage" />
            <!-- <img class="zoomed-image" :src="lCurrentImage?lCurrentImage:currentImage" alt="Current Image" /> -->

          </div>
          <hr v-if="images.length>1" class="mt-8 mb-4 bg-gray-400" />
          <!-- Slider section -->
          <div class="slider-section" v-if="images.length>1">

            <div class="slider-images">
                <template
                v-for="(image, index) in images"
                :key="index"
                >
                <img
                  :class="index==currentIndex&&!lCurrentIndex||index==lCurrentIndex?'image-borderd':''"
                  class="slider-item-img"
                  :src="image"
                  alt="Slider Image"
                  @click.stop="changeImage(index)"
                />
                </template>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import { VueImageZoomer } from 'vue-image-zoomer'
  import 'vue-image-zoomer/dist/style.css';

export default {
  props: {
    personName: String,
    time: String,
    currentImage: String,
    images: Array,
    currentIndex: Number,
    isModalOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      base_url: window.location.origin,
      lCurrentIndex:null,
      lCurrentImage:null,
      zoomLevel:1,
    };
  },
  components:{
    VueImageZoomer
  },
  computed:{
    modalState(){
        return this.isModalOpen;
    }
  },
  watch:{
    currentIndex(){
        this.lCurrentIndex = this.currentIndex;
    },
    currentImage(){
        this.lCurrentImage = this.currentImage;
    }
  },
  methods: {
    toggleModal() {
      this.$emit("update:isModalOpen", !this.isModalOpen);
    },
    changeImage(index) {
      this.lCurrentIndex = index;
      this.lCurrentImage = this.images[this.lCurrentIndex];
    },
    prevImage() {
      this.lCurrentIndex =
        (this.lCurrentIndex - 1 + this.images.length) % this.images.length;
      this.lCurrentImage = this.images[this.lCurrentIndex];
    },
    nextImage() {
      this.lCurrentIndex = (this.lCurrentIndex + 1) % this.images.length;
      this.lCurrentImage = this.images[this.lCurrentIndex];
    },
  handleKeyDown(event) {
    //   if (event.key === 'Escape') {
    //     this.toggleModal();
    //   }
    },

  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);

}
};
</script>

<style scoped lang="scss">
@import './styles/image_preview.scss'
</style>
